import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.release.diagnostics');
import { OnInit, OnDestroy, ChangeDetectorRef as CDR } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

const SYNC_LAST_RESULT_KEY = 'sync:last_result';
const SYNC_LAST_ERROR_KEY = 'sync:last_error';

@Component({
    selector: 'wiz-page-release-diagnostics',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.release.diagnostics/view.scss */
:host {
  display: block;
  min-height: 100vh;
  background: #f4f6f8;
  color: #172033;
}

.diagnostics-page {
  max-width: 1180px;
  margin: 0 auto;
  padding: 18px;
}

.diagnostics-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.header-main,
.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-block {
  min-width: 0;
}
.title-block h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 800;
  color: #121826;
}

.eyebrow {
  color: #687386;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.header-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 3px;
  color: #687386;
  font-size: 13px;
}
.header-meta .divider {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #a7b0bf;
}

.icon-button,
.action-button {
  border: 1px solid #d9dee7;
  background: #ffffff;
  color: #253247;
  cursor: pointer;
  transition: background 0.16s, border-color 0.16s, color 0.16s;
}

.icon-button {
  width: 42px;
  height: 42px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-button {
  min-height: 40px;
  border-radius: 8px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 13px;
}
.action-button.warning {
  border-color: #f2c56b;
  color: #8a5700;
  background: #fff8e8;
}
.action-button:disabled {
  opacity: 0.48;
  cursor: not-allowed;
}

.icon-button:hover,
.action-button:hover:not(:disabled) {
  background: #eef3f8;
  border-color: #c4ccd8;
}

.error-banner,
.last-error {
  display: flex;
  gap: 10px;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 14px;
  border: 1px solid #f3b9b3;
  background: #fff1ef;
  color: #a3372b;
}

.loading-state {
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #687386;
}

.diagnostics-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.field-readiness {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 14px;
  align-items: center;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #dfe4ec;
  border-left-width: 5px;
  border-radius: 8px;
}
.field-readiness.ok {
  border-left-color: #2f9e55;
  background: #f7fcf8;
}
.field-readiness.warn {
  border-left-color: #d99a20;
  background: #fffaf0;
}
.field-readiness.danger {
  border-left-color: #d94a3f;
  background: #fff5f3;
}

.readiness-icon {
  width: 42px;
  height: 42px;
  border-radius: 8px;
  background: #253247;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.readiness-copy {
  min-width: 0;
}
.readiness-copy h2 {
  margin: 2px 0 4px;
  color: #121826;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 850;
}
.readiness-copy p {
  margin: 0;
  color: #536176;
  font-size: 14px;
  line-height: 1.45;
}

.section-kicker {
  color: #687386;
  font-size: 12px;
  font-weight: 850;
}

.readiness-time {
  display: grid;
  gap: 4px;
  text-align: right;
}
.readiness-time span {
  color: #687386;
  font-size: 12px;
  font-weight: 700;
}
.readiness-time strong {
  color: #253247;
  font-size: 13px;
  white-space: nowrap;
}

.field-check-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.field-check-card {
  min-height: 118px;
  padding: 13px;
  border: 1px solid #dfe4ec;
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.field-check-card.ok {
  border-color: #b8ddc5;
  background: #f7fcf8;
}
.field-check-card.warn {
  border-color: #ecd18a;
  background: #fffaf0;
}
.field-check-card.danger {
  border-color: #efb6b0;
  background: #fff5f3;
}
.field-check-card strong {
  color: #121826;
  font-size: 20px;
  line-height: 1.2;
}
.field-check-card p {
  margin: 0;
  color: #5f6b7d;
  font-size: 13px;
  line-height: 1.4;
}

.check-head {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #536176;
  font-size: 13px;
  font-weight: 850;
}

.field-next-actions {
  padding: 14px;
  border: 1px solid #dfe4ec;
  border-radius: 8px;
  background: #ffffff;
}
.field-next-actions ul {
  margin: 0;
  padding-left: 18px;
  color: #253247;
  font-size: 14px;
  line-height: 1.6;
}

.technical-details {
  border-top: 1px solid #dfe4ec;
  padding-top: 12px;
}

.technical-summary {
  width: fit-content;
  min-height: 40px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  padding: 0 12px;
  background: #ffffff;
  color: #253247;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  list-style: none;
}
.technical-summary::-webkit-details-marker {
  display: none;
}
.technical-summary:hover {
  background: #eef3f8;
  border-color: #c4ccd8;
}

.summary-chevron {
  transition: transform 0.16s;
}

.open-label {
  display: none;
}

.technical-details[open] .summary-chevron {
  transform: rotate(180deg);
}
.technical-details[open] .closed-label {
  display: none;
}
.technical-details[open] .open-label {
  display: inline;
}

.technical-panel {
  padding-top: 12px;
}

.technical-actions {
  display: flex;
  justify-content: flex-end;
}

.technical-details > .status-grid {
  margin-top: 12px;
}

.status-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.metric-card {
  background: #ffffff;
  border: 1px solid #dfe4ec;
  border-radius: 8px;
  padding: 14px;
  min-height: 128px;
}
.metric-card.ok, .metric-card.online {
  border-color: #b8ddc5;
  background: #f3fbf5;
}
.metric-card.pending, .metric-card.syncing, .metric-card.warn {
  border-color: #ecd18a;
  background: #fff9e8;
}
.metric-card.danger, .metric-card.offline {
  border-color: #efb6b0;
  background: #fff3f1;
}

.metric-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #e9eef5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #41516a;
  margin-bottom: 12px;
}

.metric-label {
  color: #687386;
  font-size: 13px;
  font-weight: 700;
}

.metric-value {
  color: #121826;
  font-size: 24px;
  line-height: 1.15;
  font-weight: 850;
  margin-top: 4px;
}

.metric-sub {
  color: #687386;
  font-size: 12px;
  margin-top: 5px;
}

.base-url-strip {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  background: #121826;
  color: #ffffff;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 12px;
}
.base-url-strip code {
  color: #d9f99d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.url-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 800;
}

.last-error {
  align-items: flex-start;
  flex-direction: column;
}

.last-error-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 800;
}

.last-error-body {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  font-size: 13px;
}
.last-error-body small {
  color: #7f342d;
}

.technical-sections {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.technical-section {
  border: 1px solid #dfe4ec;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
}
.technical-section[open] .section-summary {
  background: #f8fafc;
  border-bottom: 1px solid #dfe4ec;
}
.technical-section .tab-panel {
  border: 0;
  border-radius: 0;
}

.section-summary {
  min-height: 42px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #253247;
  cursor: pointer;
  font-size: 13px;
  font-weight: 850;
  list-style: none;
}
.section-summary::-webkit-details-marker {
  display: none;
}
.section-summary:hover {
  background: #eef3f8;
}

.tab-panel {
  background: #ffffff;
  border: 1px solid #dfe4ec;
  border-radius: 8px;
  padding: 14px;
}

.section-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 14px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-weight: 850;
  color: #172033;
}

.path-list,
.store-grid,
.queue-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.path-row,
.store-row,
.cache-row,
.manifest-row,
.queue-row,
.runtime-row,
.summary-pill {
  border: 1px solid #e2e7ef;
  border-radius: 8px;
  background: #fbfcfe;
}

.path-row {
  padding: 10px;
  display: grid;
  gap: 6px;
}
.path-row code {
  overflow-wrap: anywhere;
  color: #41516a;
  font-size: 12px;
}
.path-row small {
  color: #a3372b;
}

.path-main,
.manifest-main,
.queue-head,
.queue-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.path-main span,
.manifest-main span,
.queue-meta span,
.queue-head span,
.queue-head small {
  color: #687386;
  font-size: 12px;
}

.store-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.store-row,
.cache-row {
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 10px;
}
.store-row span,
.cache-row span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.store-row strong,
.cache-row strong {
  flex-shrink: 0;
}

.queue-summary {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.summary-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
}
.summary-pill span {
  color: #687386;
  font-size: 12px;
  font-weight: 700;
}

.queue-row {
  padding: 11px;
  border-left-width: 4px;
}
.queue-row.danger {
  border-left-color: #d94a3f;
}
.queue-row.warn {
  border-left-color: #d99a20;
}
.queue-row.pending {
  border-left-color: #3d7bd9;
}
.queue-row.muted {
  border-left-color: #a7b0bf;
}

.queue-head {
  justify-content: space-between;
  margin-bottom: 5px;
}

.queue-error {
  margin-top: 8px;
  color: #a3372b;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.cache-row + .cache-row,
.manifest-row + .manifest-row {
  margin-top: 8px;
}

.manifest-row {
  padding: 10px;
  border-left-width: 4px;
}
.manifest-row.ok {
  border-left-color: #2f9e55;
}
.manifest-row.warn {
  border-left-color: #d99a20;
}
.manifest-row.danger {
  border-left-color: #d94a3f;
}
.manifest-row.muted {
  border-left-color: #a7b0bf;
}

.manifest-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  color: #687386;
  font-size: 12px;
}

.runtime-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.runtime-row {
  min-height: 48px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.runtime-row span {
  color: #687386;
  font-size: 13px;
  font-weight: 700;
}
.runtime-row code,
.runtime-row strong {
  min-width: 0;
  overflow-wrap: anywhere;
  text-align: right;
}
.runtime-row.full {
  grid-column: 1/-1;
  align-items: flex-start;
}

.empty-state {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #687386;
}
.empty-state.compact {
  min-height: 46px;
  justify-content: flex-start;
  padding: 8px 0;
}

.ok {
  border-color: #b8ddc5;
}

.warn {
  border-color: #ecd18a;
}

.danger {
  border-color: #efb6b0;
}

.muted {
  border-color: #dfe4ec;
}

@media (max-width: 980px) {
  .diagnostics-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .header-actions {
    width: 100%;
    flex-wrap: wrap;
  }
  .field-readiness,
  .field-check-grid,
  .status-grid,
  .section-grid,
  .runtime-grid {
    grid-template-columns: 1fr;
  }
  .base-url-strip {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 640px) {
  .diagnostics-page {
    padding: 12px;
  }
  .title-block h1 {
    font-size: 21px;
  }
  .field-readiness {
    align-items: flex-start;
  }
  .readiness-time {
    text-align: left;
  }
  .action-button {
    flex: 1 1 calc(50% - 6px);
    justify-content: center;
  }
  .store-grid {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageReleaseDiagnosticsComponent implements OnInit, OnDestroy {
    public snapshot: any = null;
    public loading: boolean = true;
    public refreshing: boolean = false;
    public runningSync: boolean = false;
    public networkStatus: string = 'online';
    public refreshError: string = '';
    public copyState: string = '';

    private _unsubNetwork: (() => void) | null = null;
    private _unsubSync: (() => void) | null = null;

    constructor(@Inject( Service)         public service: Service,@Inject( CDR)         public ref: CDR,@Inject( Router    )         public router: Router    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.service.trigger.bind('render', () => this.ref.detectChanges());

        if (!this.service.auth.allow(true)) {
            this.router.navigateByUrl('/login');
            return;
        }

        this.networkStatus = wiz.offline.network.status;
        this._unsubNetwork = wiz.offline.network.onStatusChange((status: string) => {
            this.networkStatus = status;
            this.ref.detectChanges();
        });
        this._unsubSync = wiz.offline.sync.onPendingChange(() => this.refresh(false));

        await this.refresh();
        await this.service.loading.hide();
    }

    public ngOnDestroy() {
        if (this._unsubNetwork) this._unsubNetwork();
        if (this._unsubSync) this._unsubSync();
    }

    public async refresh(showLoading: boolean = true) {
        if (showLoading) this.refreshing = true;
        this.refreshError = '';
        this.copyState = '';
        this.ref.detectChanges();

        try {
            const storage = wiz.offline.storage;
            const queueItems = await this.safe(() => storage.getSyncQueueItems ? storage.getSyncQueueItems() : storage.getAll('sync_queue'), []);
            const pendingSync = await this.safe(() => wiz.offline.pendingSync(), 0);
            const lastResult = await this.safe(() => storage.getMeta(SYNC_LAST_RESULT_KEY), null);
            const lastError = await this.safe(() => storage.getMeta(SYNC_LAST_ERROR_KEY), null);

            const [estimate, storeCounts, manifests, cacheStorage, nativePaths, serverCheck] = await Promise.all([
                this.safe(() => storage.getStorageEstimate(), { usage: 0, quota: 0 }),
                this.safe(() => storage.getStoreCounts ? storage.getStoreCounts() : [], []),
                this.safe(() => storage.getCacheManifestSummaries ? storage.getCacheManifestSummaries() : storage.getAll('cache_manifests'), []),
                this.getCacheStorageSummary(),
                this.getNativeStoragePaths(),
                this.checkServerPing()
            ]);

            this.snapshot = {
                generated_at: Date.now(),
                base_url: wiz.baseuri || '',
                network: {
                    service_status: this.networkStatus,
                    navigator_online: navigator.onLine,
                    server_check: serverCheck
                },
                platform: this.getPlatformInfo(),
                sync: this.buildSyncSummary(queueItems, pendingSync, lastResult, lastError),
                storage: {
                    estimate,
                    store_counts: storeCounts,
                    cache_storage: cacheStorage,
                    manifests,
                    paths: nativePaths
                }
            };
        } catch (error: any) {
            this.refreshError = error?.message || String(error);
        } finally {
            this.loading = false;
            this.refreshing = false;
            this.ref.detectChanges();
        }
    }

    public async forceSync() {
        if (!wiz.offline.isOnline() || this.runningSync) return;
        this.runningSync = true;
        this.ref.detectChanges();
        try {
            const result = await wiz.offline.forcSync();
            await this.refresh(false);
            await this.service.alert.show({
                title: '동기화 실행 완료',
                message: `성공 ${result.success || 0}건, 실패 ${result.failed || 0}건`,
                status: result.failed > 0 ? 'warning' : 'success',
                action: '확인'
            });
        } finally {
            this.runningSync = false;
            this.ref.detectChanges();
        }
    }

    public async copySnapshot() {
        if (!this.snapshot) return;
        const text = JSON.stringify(this.snapshot, null, 2);
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(text);
            } else {
                const textarea = document.createElement('textarea');
                textarea.value = text;
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
            }
            this.copyState = '복사됨';
        } catch (error) {
            this.copyState = '복사 실패';
        }
        this.ref.detectChanges();
    }

    public goBack() {
        this.router.navigateByUrl('/home');
    }

    public formatBytes(value: any): string {
        const bytes = Number(value || 0);
        if (!bytes) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        let size = bytes;
        let unit = 0;
        while (size >= 1024 && unit < units.length - 1) {
            size = size / 1024;
            unit++;
        }
        return `${size.toFixed(unit === 0 ? 0 : 1)} ${units[unit]}`;
    }

    public formatTimestamp(value: any): string {
        if (!value) return '-';
        const date = new Date(typeof value === 'number' ? value : String(value));
        if (Number.isNaN(date.getTime())) return String(value);
        return date.toLocaleString('ko-KR', {
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }

    public storageUsagePercent(): number {
        const estimate = this.snapshot?.storage?.estimate || {};
        const usage = Number(estimate.usage || 0);
        const quota = Number(estimate.quota || 0);
        if (!usage || !quota) return 0;
        return Math.min(100, Math.round((usage / quota) * 100));
    }

    public getStatusLabel(status: string): string {
        if (status === 'online') return '온라인';
        if (status === 'syncing') return '동기화 중';
        return '오프라인';
    }

    public getFieldReadinessClass(): string {
        const failed = this.getSyncFailedCount();
        const pending = this.getSyncPendingCount();
        const manifests = this.getManifests();
        const blocking = this.getManifestBlockingCount();
        const online = this.isNavigatorOnline();

        if (failed > 0 || (!online && manifests.length === 0)) return 'danger';
        if (manifests.length === 0 || blocking > 0 || pending > 0 || !online) return 'warn';
        return 'ok';
    }

    public getFieldReadinessLabel(): string {
        const failed = this.getSyncFailedCount();
        const pending = this.getSyncPendingCount();
        const manifests = this.getManifests();
        const blocking = this.getManifestBlockingCount();
        const online = this.isNavigatorOnline();

        if (failed > 0) return '동기화 확인 필요';
        if (!online && manifests.length === 0) return '오프라인 준비 필요';
        if (manifests.length === 0) return '사전 다운로드 대기';
        if (blocking > 0) return '사전 다운로드 확인 필요';
        if (pending > 0) return '동기화 대기 중';
        if (!online) return '오프라인 작업 가능';
        return '현장 작업 가능';
    }

    public getFieldReadinessDescription(): string {
        const failed = this.getSyncFailedCount();
        const pending = this.getSyncPendingCount();
        const manifests = this.getManifests();
        const blocking = this.getManifestBlockingCount();
        const online = this.isNavigatorOnline();

        if (failed > 0) return '저장한 작업 중 서버 반영에 실패한 항목이 있습니다.';
        if (!online && manifests.length === 0) return '저장된 현장 자료가 없어 오프라인 작업을 시작하기 어렵습니다.';
        if (manifests.length === 0) return '홈에서 선택한 작업 자료가 자동 준비되는지 확인하세요.';
        if (blocking > 0) return '필수 자료 일부가 준비되지 않았습니다. 온라인 상태에서 자동 준비가 끝나야 합니다.';
        if (pending > 0) return '오프라인에서 저장한 작업이 서버 반영을 기다리고 있습니다.';
        if (!online) return '네트워크가 없어도 준비된 현장 자료로 작업할 수 있습니다.';
        return '자료 준비와 동기화 상태가 정상입니다.';
    }

    public getFieldNetworkClass(): string {
        return this.isNavigatorOnline() ? 'ok' : 'warn';
    }

    public getFieldNetworkLabel(): string {
        return this.isNavigatorOnline() ? '온라인' : '오프라인';
    }

    public getFieldNetworkText(): string {
        const server = this.snapshot?.network?.server_check;
        if (!this.isNavigatorOnline()) return '현장 저장은 가능하며, 연결되면 자동 동기화됩니다.';
        if (server?.ok) return `서버 연결 정상 · ${server.latency_ms}ms`;
        return '인터넷은 연결되었지만 서버 확인이 필요합니다.';
    }

    public getFieldCacheClass(): string {
        const manifests = this.getManifests();
        if (manifests.length === 0) return this.isNavigatorOnline() ? 'warn' : 'danger';
        return this.getManifestBlockingCount() > 0 ? 'warn' : 'ok';
    }

    public getFieldCacheLabel(): string {
        const manifests = this.getManifests();
        if (manifests.length === 0) return '준비 전';
        return this.getManifestBlockingCount() > 0 ? '확인 필요' : '준비 완료';
    }

    public getFieldCacheText(): string {
        const manifests = this.getManifests();
        if (manifests.length === 0) return '온라인 상태에서 홈 진입 시 자동 준비됩니다.';

        const latest = this.getLatestManifestUpdatedAt();
        const blocking = this.getManifestBlockingCount();
        if (blocking > 0) return `필수 자료 ${blocking}건을 더 받아야 합니다.`;
        return `최근 준비 ${this.formatTimestamp(latest)} · ${manifests.length}개 작업`;
    }

    public getFieldSyncClass(): string {
        if (this.getSyncFailedCount() > 0) return 'danger';
        return this.getSyncPendingCount() > 0 ? 'warn' : 'ok';
    }

    public getFieldSyncLabel(): string {
        if (this.getSyncFailedCount() > 0) return '실패 있음';
        return this.getSyncPendingCount() > 0 ? '대기 중' : '동기화 완료';
    }

    public getFieldSyncText(): string {
        const pending = this.getSyncPendingCount();
        const failed = this.getSyncFailedCount();
        if (failed > 0) return `실패 ${failed}건 · 온라인 상태에서 다시 실행하세요.`;
        if (pending > 0) return `서버 반영 대기 ${pending}건`;

        const finishedAt = this.snapshot?.sync?.last_result?.finished_at;
        if (finishedAt) return `최근 동기화 ${this.formatTimestamp(finishedAt)}`;
        return '대기 중인 작업이 없습니다.';
    }

    public getFieldStorageClass(): string {
        const percent = this.storageUsagePercent();
        if (percent >= 90) return 'danger';
        if (percent >= 80) return 'warn';
        return 'ok';
    }

    public getFieldStorageLabel(): string {
        const percent = this.storageUsagePercent();
        if (percent >= 90) return '공간 부족';
        if (percent >= 80) return '공간 확인';
        return '여유 있음';
    }

    public getFieldStorageText(): string {
        const estimate = this.snapshot?.storage?.estimate || {};
        return `${this.formatBytes(estimate.usage)} 사용 · ${this.storageUsagePercent()}%`;
    }

    public getFieldNextActions(): string[] {
        const actions: string[] = [];
        const failed = this.getSyncFailedCount();
        const pending = this.getSyncPendingCount();
        const manifests = this.getManifests();
        const blocking = this.getManifestBlockingCount();
        const online = this.isNavigatorOnline();

        if (failed > 0) actions.push('동기화 실패 항목은 온라인 상태에서 다시 동기화하세요.');
        if (pending > 0) actions.push('남은 작업은 연결되면 자동으로 서버에 반영됩니다.');
        if (manifests.length === 0 || blocking > 0) actions.push('온라인 상태에서 홈으로 돌아가면 현장 자료가 자동 준비됩니다.');
        if (!online && manifests.length > 0 && blocking === 0) actions.push('오프라인 상태에서는 저장을 계속하고, 연결 후 동기화 여부만 확인하세요.');
        if (!actions.length) actions.push('추가 조치 없이 현장 점검을 진행해도 됩니다.');
        return actions.slice(0, 3);
    }

    public getQueuePreview(): any[] {
        return this.snapshot?.sync?.items_preview || [];
    }

    public getManifests(): any[] {
        return this.snapshot?.storage?.manifests || [];
    }

    public getStoreCounts(): any[] {
        return this.snapshot?.storage?.store_counts || [];
    }

    public getStoragePaths(): any[] {
        return this.snapshot?.storage?.paths || [];
    }

    public getCacheEntries(): any[] {
        return this.snapshot?.storage?.cache_storage?.entries || [];
    }

    public getLastSyncError(): any {
        return this.snapshot?.sync?.last_error || null;
    }

    public getServerCheckClass(): string {
        const server = this.snapshot?.network?.server_check;
        if (!server) return 'muted';
        return server.ok ? 'ok' : 'danger';
    }

    public getManifestClass(status: string): string {
        if (status === 'completed') return 'ok';
        if (status === 'failed') return 'danger';
        if (status === 'partial') return 'warn';
        return 'muted';
    }

    public getManifestStatusText(manifest: any): string {
        if (!manifest) return '-';
        if (manifest.status === 'completed' && Number(manifest.optional_unavailable_items || 0) > 0) {
            return 'completed · diagnostic ready';
        }
        return manifest.status || '-';
    }

    public getManifestRequiredText(manifest: any): string {
        if (!manifest) return '필수 -';
        const total = Number(manifest.required_items ?? manifest.total_items ?? 0);
        const cached = Number(manifest.required_cached_items ?? manifest.cached_items ?? 0);
        const blocking = Number(manifest.blocking_items ?? 0);
        return `필수 ${cached}/${total}${blocking > 0 ? ` · 확인 ${blocking}` : ''}`;
    }

    public getManifestOptionalText(manifest: any): string {
        if (!manifest || Number(manifest.optional_items || 0) === 0) return '선택 -';
        const cached = Number(manifest.optional_cached_items || 0);
        const total = Number(manifest.optional_items || 0);
        const unavailable = Number(manifest.optional_unavailable_items || 0);
        return `선택 ${cached}/${total}${unavailable > 0 ? ` · 미준비 ${unavailable}` : ''}`;
    }

    public getPathClass(path: any): string {
        if (!path) return 'muted';
        if (path.status === 'ok') return 'ok';
        if (path.status === 'error') return 'danger';
        return 'muted';
    }

    public queueStatusClass(status: string): string {
        if (status === 'failed') return 'danger';
        if (status === 'syncing') return 'warn';
        if (status === 'pending') return 'pending';
        return 'muted';
    }

    private isNavigatorOnline(): boolean {
        return !!this.snapshot?.network?.navigator_online;
    }

    private getSyncPendingCount(): number {
        return Number(this.snapshot?.sync?.pending || 0);
    }

    private getSyncFailedCount(): number {
        return Number(this.snapshot?.sync?.failed || 0);
    }

    private getManifestBlockingCount(): number {
        return this.getManifests().reduce((sum: number, manifest: any) => {
            return sum + Number(manifest?.blocking_items || 0);
        }, 0);
    }

    private getLatestManifestUpdatedAt(): any {
        const latest = this.getManifests().reduce((max: number, manifest: any) => {
            return Math.max(max, Number(manifest?.updated_at || manifest?.completed_at || 0));
        }, 0);
        return latest || null;
    }

    private async safe<T>(fn: () => Promise<T>, fallback: T): Promise<T> {
        try {
            return await fn();
        } catch (error) {
            console.warn('[Diagnostics] read failed:', error);
            return fallback;
        }
    }

    private buildSyncSummary(queueItems: any[], pendingSync: number, lastResult: any, lastError: any): any {
        const byStatus: any = {};
        const byEntity: any = {};
        for (const item of queueItems || []) {
            const status = item.status || 'unknown';
            const entity = item.entity_type || 'unknown';
            byStatus[status] = (byStatus[status] || 0) + 1;
            byEntity[entity] = (byEntity[entity] || 0) + 1;
        }

        const latestQueueError = this.findLatestQueueError(queueItems || []);
        const preview = [...(queueItems || [])]
            .sort((a: any, b: any) => Number(b.updated_at || b.created_at || 0) - Number(a.updated_at || a.created_at || 0))
            .slice(0, 12);

        return {
            total: (queueItems || []).length,
            pending: pendingSync,
            failed: Number(byStatus.failed || 0),
            syncing: Number(byStatus.syncing || 0),
            by_status: byStatus,
            by_entity_type: byEntity,
            last_result: lastResult,
            last_error: lastError || latestQueueError,
            items_preview: preview
        };
    }

    private findLatestQueueError(items: any[]): any {
        const failed = items
            .filter((item: any) => item && (item.error || item.status === 'failed'))
            .sort((a: any, b: any) => Number(b.updated_at || b.created_at || 0) - Number(a.updated_at || a.created_at || 0));
        if (!failed.length) return null;
        const item = failed[0];
        return {
            item_id: item.id,
            entity_type: item.entity_type,
            entity_id: item.entity_id,
            action: item.action,
            retry_count: item.retry_count || 0,
            error: item.error || '',
            occurred_at: item.updated_at || item.created_at
        };
    }

    private async getCacheStorageSummary(): Promise<any> {
        const cacheApi = (window as any).caches;
        if (!cacheApi || !cacheApi.keys) {
            return { available: false, entries: [], total_entries: 0 };
        }

        const keys = await cacheApi.keys();
        const entries = [];
        for (const key of keys.filter((name: string) => String(name).startsWith('inspectpro-'))) {
            try {
                const cache = await cacheApi.open(key);
                const requests = await cache.keys();
                entries.push({ name: key, count: requests.length });
            } catch (error: any) {
                entries.push({ name: key, count: 0, error: error?.message || String(error) });
            }
        }
        return {
            available: true,
            entries,
            total_entries: entries.reduce((sum: number, item: any) => sum + Number(item.count || 0), 0)
        };
    }

    private async getNativeStoragePaths(): Promise<any[]> {
        const paths: any[] = [
            { label: 'IndexedDB', directory: 'inspectpro-offline', path: 'inspectpro-offline', status: 'ok', uri: 'WebView IndexedDB' },
            { label: 'CacheStorage', directory: 'inspectpro-*', path: 'inspectpro-static / inspectpro-api / inspectpro-pdf', status: 'ok', uri: 'Service Worker CacheStorage' },
            { label: 'Export public', directory: 'DOCUMENTS', path: 'inspectPRO', status: 'unchecked', uri: 'Capacitor Documents/inspectPRO' },
            { label: 'Export fallback', directory: 'EXTERNAL', path: 'inspectPRO', status: 'unchecked', uri: 'Capacitor External/inspectPRO' },
            { label: 'App data', directory: 'DATA', path: 'inspectPRO', status: 'unchecked', uri: 'Capacitor Data/inspectPRO' }
        ];

        const capacitor = (window as any).Capacitor;
        const filesystem = capacitor?.Plugins?.Filesystem;
        const isNative = !!capacitor && !!capacitor.isNativePlatform && capacitor.isNativePlatform();
        if (!isNative || !filesystem || typeof filesystem.getUri !== 'function') return paths;

        for (const item of paths.filter(path => path.status === 'unchecked')) {
            try {
                const result = await filesystem.getUri({ path: item.path, directory: item.directory });
                item.status = 'ok';
                item.uri = result?.uri || item.uri;
            } catch (error: any) {
                item.status = 'error';
                item.error = error?.message || String(error);
            }
        }
        return paths;
    }

    private getPlatformInfo(): any {
        const capacitor = (window as any).Capacitor;
        const isNative = !!capacitor && !!capacitor.isNativePlatform && capacitor.isNativePlatform();
        let platform = 'web';
        try {
            platform = capacitor?.getPlatform ? capacitor.getPlatform() : (isNative ? 'native' : 'web');
        } catch {}

        return {
            capacitor_native: isNative,
            capacitor_platform: platform,
            user_agent: navigator.userAgent,
            language: navigator.language,
            viewport: `${window.innerWidth}x${window.innerHeight}`,
            device_pixel_ratio: window.devicePixelRatio || 1,
            plugins: capacitor?.Plugins ? Object.keys(capacitor.Plugins).sort() : []
        };
    }

    private async checkServerPing(): Promise<any> {
        const started = performance.now();
        const url = this.resolveServerUrl('/api/sync/ping');
        try {
            const response = await fetch(url, {
                method: 'GET',
                cache: 'no-store',
                credentials: 'include'
            });
            return {
                ok: response.ok,
                status: response.status,
                latency_ms: Math.round(performance.now() - started),
                url,
                checked_at: Date.now()
            };
        } catch (error: any) {
            return {
                ok: false,
                status: 0,
                latency_ms: Math.round(performance.now() - started),
                url,
                error: error?.message || String(error),
                checked_at: Date.now()
            };
        }
    }

    private resolveServerUrl(path: string): string {
        const base = String(wiz.baseuri || '').trim();
        if (/^https?:\/\//.test(base)) {
            try {
                return new URL(path, new URL(base).origin).toString();
            } catch {
                return path;
            }
        }
        return path;
    }
}

export default PageReleaseDiagnosticsComponent;